import {inject, Injectable} from '@angular/core';
import {BASE_URL} from "../app.environment";
import {HttpClient} from "@angular/common/http";
import {catchError, Observable, of, tap} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  httpClient = inject(HttpClient)
  baseApiUrl = BASE_URL;
  token: string | undefined | null = localStorage.getItem('auth_token');

  constructor() {
  }

  isAuth() {
    return !!this.getToken()
  }

  login(username: string, password: string): Observable<any> {
    return this.httpClient.post(`${this.baseApiUrl}/login`, {username, password}).pipe(
      tap((response: any) => {
        this.token = response.token;
        if (this.token) {
          localStorage.setItem('auth_token', this.token);
        }
      }),
      catchError(this.handleError('login', []))
    );
  }

  getToken(): string | null {
    return this.token || localStorage.getItem('auth_token');
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
}
